module.exports = __webpack_public_path__ + "assets/img/右箭头.44523445.png";